import React, { useEffect, useState, useRef } from 'react';
import { base_url } from '../../Api/Api';
import { Loader } from '../../Global/Loader';

import Header from '../../Global/Header';
import ItemCrs from './itemCourse';

const MyCourses = (props) => {

    const [state, setState] = useState({
        courses: [],
        loader: true,
        animToggle: false
    })

    useEffect(() => {


        base_url.get(`my_courses`)
            .then(response => {
                console.log(response.data, 'my courses')
                setState({
                    ...state,
                    courses: response.data.courses,
                    loader: false,
                    animToggle: true
                })
            })
            .catch(error => {
                if (error.response != undefined) {
                    console.log(error)
                    if (error.response.status == 401) {
                        localStorage.clear()
                        props.history.push(`/Entrance`)
                        window.location.reload()
                    }
                }
            })

    }, [])

    return (
        <React.Fragment>
            <Loader
                active={state.loader} />
            <div className={`instructpg main-courses ${state.animToggle ? 'active' : ''}`}>
                <Header
                    innerPage={true}
                    title={'کرس های من'} />

                <div className="body-courses">

                    {state.courses.length == 0 ?
                        <span className="no-info"> <i className="icon-newsfeed"></i> کرسی برای نمایش وجود ندارد. </span>
                        :
                        state.courses.map(item =>
                            <ItemCrs
                                data={item} />
                        )
                    }

                </div>

            </div>
        </React.Fragment>
    );
}

export default MyCourses;